export const statusList = [
  { id: -1, name: 'All Status' },
  { id: 1, name: 'Active' },
  { id: 2, name: 'Inactive' },
];

export const hubType = [
  { id: -1, name: 'All hub types' },
  { id: 1, name: 'Transporter Hub' },
];

export const filters = {
  STATUS: 'Status',
  HUB_TYPE: 'hubType',
};
